import error from '../../assets/images/404.png'

const ErrrorPage = () => {


    return (
        <div className="error-page-container">
            <img src={error} alt="" />
        </div>
    )
}
export default ErrrorPage